/* eslint-disable @typescript-eslint/no-unused-vars */
export interface ScrollState {
  scrollTop: number;
  scrollHeight: number;
  offsetHeight: number;
  distanceFromBottom: number;
  isAtBottom: boolean;
  isScrollingUp: boolean;
  isScrollingDown: boolean;
}

export function getScrollState(element: HTMLElement, lastScrollTop: number): ScrollState {
  const { scrollTop, scrollHeight, offsetHeight } = element;
  const distanceFromBottom = scrollHeight - (scrollTop + offsetHeight);
  const isAtBottom = distanceFromBottom === 0;
  const isScrollingUp = scrollTop < lastScrollTop;
  const isScrollingDown = scrollTop > lastScrollTop;

  return {
    scrollTop: Math.max(scrollTop, 0),
    scrollHeight,
    offsetHeight,
    distanceFromBottom,
    isAtBottom,
    isScrollingUp,
    isScrollingDown,
  };
}

export function isScrollAtBottom(element: HTMLElement): boolean {
  const { scrollTop, scrollHeight, offsetHeight } = element;
  const distanceFromBottom = scrollHeight - (scrollTop + offsetHeight);
  return distanceFromBottom === 0;
}

export function isShowScrollNeeded(element: HTMLElement, threshold = 100): boolean {
  const { scrollTop, scrollHeight, offsetHeight } = element;
  const distanceFromBottom = scrollHeight - (scrollTop + offsetHeight);
  return distanceFromBottom > threshold;
}

export function scrollToBottom(element: HTMLElement, smooth = true): void {
  element.scrollTo({
    top: element.scrollHeight,
    behavior: smooth ? 'smooth' : 'auto',
  });
}

export function scrollToBottomDelayed(element: HTMLElement, delay = 1000, smooth = true): void {
  setTimeout(() => scrollToBottom(element, smooth), delay);
}

export function calculateAutoScrollState(
  scrollState: ScrollState,
  currentAutoScroll: boolean,
): boolean {
  const { isScrollingUp, isScrollingDown, distanceFromBottom } = scrollState;

  // Disable auto-scroll when user scrolls up, unless they're still at the bottom
  if (isScrollingUp && distanceFromBottom > 5) {
    return false;
  }

  // Re-enable auto-scroll only when user scrolls to the very bottom (within 5px)
  if (distanceFromBottom <= 5 && !currentAutoScroll) {
    return true;
  }

  return currentAutoScroll;
}
